import { Injectable, Provider } from "@angular/core";
import { Message } from "primeng/api";
import { MessageService } from "primeng/api";

export const provideMessageService: () => Provider = () => ({
  provide: MessageService,
  useClass: CustomMessageService,
});

@Injectable()
export class CustomMessageService extends MessageService {
  private readonly ERROR_ICON = "pi-exclamation-circle";

  override add(message: Message) {
    super.add(this.customizeErrorMessage(message));
  }

  override addAll(messages: Message[]) {
    super.addAll(
      messages.map((message) => this.customizeErrorMessage(message)),
    );
  }

  private customizeErrorMessage(message: Message): Message {
    if (message.severity === "error" && !message.icon)
      message.icon = this.ERROR_ICON;

    return message;
  }
}
